import { createSlice, createSelector } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";
import config from "../../config.json";

const slice = createSlice({
  name: "timeLogInvoice",
  initialState: {
    list: [],
    loading: false,
    lastFetch: null,
    subInvDocDeleteStatus: false,
    recInvDocDeleteStatus: false,
    agencyInvDocDeleteStatus: false,
    invoiceUploadResponse: null,
    invoiceUpdateStatus: false,
  },
  reducers: {
    timeLogInvoiceRequested: (timeLogInvoice, action) => {
      timeLogInvoice.loading = true;
      timeLogInvoice.list = [];
    },
    timeLogInvoiceRequestFailed: (timeLogInvoice, action) => {
      timeLogInvoice.loading = false;
    },
    timeLogInvocieReceived: (timeLogInvoice, action) => {
      timeLogInvoice.list = action.payload;
      timeLogInvoice.loading = false;
      timeLogInvoice.lastFetch = Date.now();
      timeLogInvoice.subInvDocDeleteStatus = false;
      timeLogInvoice.recInvDocDeleteStatus = false;
      timeLogInvoice.agencyInvDocDeleteStatus = false;
      timeLogInvoice.invoiceUploadResponse = null;
      timeLogInvoice.invoiceUpdateStatus = false;
    },
    taskDone: (timeLogInvoice, action) => {
      timeLogInvoice.loading = false;
    },
    ruleAppDataReceived: (timeLogInvoice, action) => {
      timeLogInvoice.ruleAppData = action.payload;
    },
    subTimeLogInvDocDeleted: (timeLogInvoice, action) => {
      timeLogInvoice.subInvDocDeleteStatus = action.payload;
    },
    recTimeLogInvDocDeleted: (timeLogInvoice, action) => {
      timeLogInvoice.recInvDocDeleteStatus = action.payload;
    },
    agencyTimeLogInvDocDeleted: (timeLogInvoice, action) => {
      timeLogInvoice.agencyInvDocDeleteStatus = action.payload;
    },
    timeLogInvoiceDocumentUploaded: (timeLogInvoice, action) => {
      timeLogInvoice.invoiceUploadResponse = action.payload;
    },
    timeLogInvoiceUpdated: (timeLogInvoice, action) => {
      timeLogInvoice.invoiceUpdateStatus = action.payload;
    },
  },
});

export const {
  timeLogInvoiceRequested,
  timeLogInvoiceRequestFailed,
  timeLogInvocieReceived,
  taskDone,
  ruleAppDataReceived,
  subTimeLogInvDocDeleted,
  recTimeLogInvDocDeleted,
  agencyTimeLogInvDocDeleted,
  timeLogInvoiceDocumentUploaded,
  timeLogInvoiceUpdated,
} = slice.actions;
export default slice.reducer;

export const loadTimeLogInvoice = (id) =>
  apiCallBegan({
    url: config.GetTimeLogInvoice + id,
    onStart: timeLogInvoiceRequested.type,
    onSuccess: timeLogInvocieReceived.type,
    onError: timeLogInvoiceRequestFailed.type,
  });

export const deleteAgencyTimeLogInvDoc = (id) =>
  apiCallBegan({
    url: config.DeleteTimeLogInvoiceDoc + id,
    method: "delete",
    onSuccess: agencyTimeLogInvDocDeleted.type,
  });
export const deleteSubcontractorTimeLogInvDoc = (id) =>
  apiCallBegan({
    url: config.DeleteTimeLogInvoiceDoc + id,
    method: "delete",
    onSuccess: subTimeLogInvDocDeleted.type,
  });

export const deleteRecruiterTimeLogInvDoc = (id) =>
  apiCallBegan({
    url: config.DeleteTimeLogInvoiceDoc + id,
    method: "delete",
    onSuccess: recTimeLogInvDocDeleted.type,
  });

export const uploadTimeLogInvoiceDocument = (data) =>
  apiCallBegan({
    url: config.ApplicantUploadDocument,
    method: "post",
    data: data,
    onSuccess: timeLogInvoiceDocumentUploaded.type,
    throwOnError: true,
  });

export const updateTimeLogInvoice = (data) =>
  apiCallBegan({
    url: config.UpdateTimeLogInvoice,
    method: "post",
    data: data,
    onSuccess: timeLogInvoiceUpdated.type,
    throwOnError: true,
  });

export const getTimeLogInvoice = createSelector(
  (state) => state.entities.timeLogInvoice,
  (timeLogInvoice) => timeLogInvoice.list,
);

export const getSubTimeLogInvDocDeleteStatus = createSelector(
  (state) => state.entities.timeLogInvoice,
  (timeLogInvoice) => timeLogInvoice.subInvDocDeleteStatus,
);

export const getRecTimeLogInvDocDeleteStatus = createSelector(
  (state) => state.entities.timeLogInvoice,
  (timeLogInvoice) => timeLogInvoice.recInvDocDeleteStatus,
);
export const getAgencyTimeLogInvDocDeleteStatus = createSelector(
  (state) => state.entities.timeLogInvoice,
  (timeLogInvoice) => timeLogInvoice.agencyInvDocDeleteStatus,
);

export const getTimeLogInvoiceUploadResponse = createSelector(
  (state) => state.entities.timeLogInvoice,
  (timeLogInvoice) => timeLogInvoice.invoiceUploadResponse,
);

export const getTimeLogInvoiceUpdateStatus = createSelector(
  (state) => state.entities.timeLogInvoice,
  (timeLogInvoice) => timeLogInvoice.invoiceUpdateStatus,
);
